import { TrackSymptomHeaderType } from "./track";

export interface SymptomTrackerProps {
  category: TrackSymptomHeaderType;
  tracker: Array<any> | [];
}

export interface QuestionByCatrgoryType {
  category: string;
  category_id: string;
  description: string;
  questions: Array<QuestionType>;
  nextCategory?: string;
}

export interface QuestionType {
  answer?: string;
  options: Array<OptionType>;
  question: string;
  question_id: string;
  short_name: string;
  id: string; // id and question_id both are same
  info: string;
}

export interface OptionType {
  label: string;
  selected?: boolean;
  value: string;
}

export interface SymptopQuestionProps {
  categoryName: string;
  categoryQuestion: QuestionByCatrgoryType;
  setAnswers: Function;
  answers: AnswerType;
  categoryId: string;
}

export interface SymptopQuestionSlideProps {
  finalSubmitCallback: () => void;
  categoryId: string;
  slideDetailsCallBack: any;
}

export interface GetQuestionbyCatrgoryType {
  questionNdx: number;
  categoryName: string | null;
}

export enum SaveBtnType {
  CONTINUE = "continue",
  EXIT = "exit",
}

export enum CategoryType {
  VASOMOTOR = "Vasomotor",
  PHYSICAL = "Physical",
  MOOD_AND_MENTAL = "Mood and mental",
  SLEEP = "Sleep",
  SEXUAL_AND_URINARY_HEALTH = "Sexual and urinary health",
}

export interface DateDifferenceProps {
  start_date: string | boolean;
  last_date: string | boolean;
}

export interface TrackerData {
  date: string | number; // Date of the entry
  isPeriodLogged?: boolean; // Whether a period is logged for that date
  symptom_tracked?: boolean; // Whether symptoms are tracked for that date
  mood_tracked?: number;
}

export interface AnswerType {
  submissionDate: string;
  record_id: string;
  symptoms: Array<SymptomsType> | [];
}

export interface SymptomsType {
  category_id: string;
  answers: Array<SelectedAnswerType>;
}

export interface SelectedAnswerType {
  question_id: string;
  response: string;
  short_name: string;
}
